"use client";

import dynamic from "next/dynamic";

export const BlockCategorizedAgentDemosWrapper = dynamic(() =>
  import("./BlockCategorizedAgentDemos").then(mod => mod.BlockCategorizedAgentDemos),
);
